import Photo from "../../../../assets/images/pictures/house_main.jpg";

export default {
  name: "non_registered",

  data() {
    return {
      boostChange: false
    };
  },

  props: {
    offPropertyNumber: {
      type: Object,
      default: () => {}
    }
  },

  mounted: function() {},

  methods: {
    isModalChange() {
      this.boostChange = !this.boostChange;
    },

    photo() {
      return Photo;
    }
  },

  watch: {
    boostChange: function(newValue) {
      this.$emit("handleBoostChange", newValue);
    }
  },

  components: {
    Photo
  },

};
